import React from 'react';
import { withStyles } from '@material-ui/core';
import { Link } from 'react-router-dom';
import AdminButton, { BUTTON_TYPE_EDIT } from '../../common/AdminButton';
import { AddCircleOutline } from '@material-ui/icons';

const styles = {
    root: {
        minWidth: 280,
    },
    addCircleIcon: {
        marginRight: 25,
    },
};

const AddUserButton = ({ classes, history, ...props }) => {
    return (
        <AdminButton
            buttonType={BUTTON_TYPE_EDIT}
            size="large"
            className={classes.root}
            component={Link}
            to={'/users/new'}
            {...props}
        >
            <AddCircleOutline className={classes.addCircleIcon} />
            Add User
        </AdminButton>
    );
};

export default withStyles(styles)(AddUserButton);
